import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * Legacy single-space explorer URL → project-level "Folders" URL.
 *
 * Old:  /workspace/:workspaceId/explorer?projectId=<id>#folderPath=/<folderIds>/
 * New:  /project/:projectId/folders?projectId=<id>#folderPath=/<workspaceId>/<folderIds>/
 *
 * The Space id lived in the PATH (`workspaceId`) on the old URL, but on the new one it must be the FIRST
 * hash segment so the Folders page can focus that Space (and restore the nested folder). We keep the query
 * string intact (projectId lives there on both URLs) and just prefix the Space id onto the folder-id hash.
 */
const RedirectExplorerToFolders = () => {
  const { workspaceId } = useParams();
  const location = useLocation();
  const projectId = new URLSearchParams(location.search).get("projectId");

  // Without a projectId we cannot build the /project/:projectId/folders path — fall back to the projects list.
  if (!projectId || !workspaceId) {
    return <Navigate to="/projects" replace />;
  }

  // Old hash carries only folder ids (#folderPath=/id1/id2/). Extract them, then prefix the Space id so the
  // new hash becomes /<workspaceId>/id1/id2/. With no folder ids, just focus the Space root (/<workspaceId>/).
  let folderIds = "";
  if (location.hash) {
    const decoded = decodeURIComponent(location.hash.replace(/^#/, "")); // "folderPath=/id1/id2/"
    const value = decoded.slice(decoded.indexOf("=") + 1); // "/id1/id2/"
    folderIds = value.split("/").filter(Boolean).join("/"); // "id1/id2"
  }
  const folderPath = folderIds ? `/${workspaceId}/${folderIds}/` : `/${workspaceId}/`;
  const to = `/project/${projectId}/folders${location.search}#folderPath=${encodeURIComponent(folderPath)}`;

  return <Navigate to={to} replace />;
};

export default RedirectExplorerToFolders;
